module.exports = __webpack_public_path__ + "img/pic_title_img1.1f1f38bc.png";